import { gql, type TypedDocumentNode } from '@apollo/client';

import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { SquadBoard } from '#src/components/squad/SquadBoard/index.tsx';
import { SquadWelcomeDialog } from '#src/components/squad/SquadWelcomeDialog/index.tsx';

import type {
  SquadPageQuery,
  SquadPageQueryVariables,
} from './__generated__/page.graphql.ts';

const SQUAD_PAGE_QUERY = gql`
  query SquadPageQuery($sport: Sport!) {
    currentUser {
      slug
      squad(sport: $sport) {
        id
      }
      ...SquadBoard_currentUser
    }
  }
  ${SquadBoard.fragments.currentUser}
` as TypedDocumentNode<SquadPageQuery, SquadPageQueryVariables>;

export const loader = queryLoader(SQUAD_PAGE_QUERY, ({ sport }) => ({
  sport,
}));

const SquadPage = () => {
  const { data } = useQueryLoader<SquadPageQuery>();
  const { currentUser } = data;

  if (currentUser?.squad) {
    return <SquadBoard currentUser={currentUser} />;
  }

  return <SquadWelcomeDialog />;
};
export default SquadPage;
